export default __webpack_public_path__ + "static/media/petpartners-logo.e0a8534f.svg";